import React, { useState, useEffect } from "react";
import TableIconModal from "../../../shares/TableIconModal";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import MuiButton from "../../../shares/MuiButton";
import DoneIcon from "@mui/icons-material/Done";
import useFetch from "../../../../context/useFetch";
import { toast } from "react-toastify";
import AdminOrderCard from "../../shares/AdminOrderCard";
import moment from "jalali-moment";
import OrderCardLeftPartTemplate from "../../../shares/OrderCardLeftPartTemplate";
import { fixNumbers } from "../../../../utils";

const OrderDetails = (props) => {
  let windowWidth = window.screen.width;
  const [openModal, setOpenModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [patchData, setPatchData] = useState();
  const [childrenItemDate, setChildrenItemDate] = useState();
  const [selecteItemStatus, setSelectItemStatus] = useState();
  const [currentOerdersDetail, setCurrentOerdersDetail] = useState(undefined);
  const [initialValues, setInitialValues] = useState({});
  const [nums, setNums] = useState(new Array(6).fill(""));
  const update_nums = (ringId, ind, nValue) => {
    let beforeNums = { ...initialValues };

    beforeNums[ringId][ind] = nValue;
    setInitialValues(beforeNums);
  };

  const getCreateOrderDetailsApi = useFetch({
    method: "get",
    url: `BangleStock_Service/${props.selectedRow?.id}`,
    trigger: false,
    setter: setCurrentOerdersDetail,
    // params: { admin_change_item: false },
    argFunc: (res) => {
      let tmp = {};
      // res.results.map((item, ind) => {
      tmp[res.id] = [];
      tmp[res.id].push(res.size_one_num);
      tmp[res.id].push(res.size_two_num);
      tmp[res.id].push(res.size_three_num);
      tmp[res.id].push(res.size_four_num);
      tmp[res.id].push(res.size_five_num);
      tmp[res.id].push(res.size_six_num);
      // });

      setInitialValues(tmp);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const updateDetailsApi = useFetch({
    method: "patch",
    url: `BangleStock_Service/${selectedItem}`,
    trigger: false,
    data: patchData,

    argFunc: (res) => {
      // toast.success("ویرایش موجودی  با موفقیت انجام شد.", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      getCreateOrderDetailsApi.reFetch();
      props.getRequestListApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const deleteDetailsApi = useFetch({
    method: "patch",
    url: `BangleStock_Service/${selectedItem}`,
    trigger: false,
    data: { is_active: !selecteItemStatus },
    argFunc: (res) => {
      // toast.success("ویرایش مورد نظر  با موفقیت انجام شد.", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      getCreateOrderDetailsApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_ring_item = (ringItemId) => {
    setSelectedItem(ringItemId);
    setPatchData({
      size_one_num:
        initialValues[ringItemId][0] !== "" ?parseInt(fixNumbers( initialValues[ringItemId][0])) : 0,
      size_two_num:
        initialValues[ringItemId][1] !== "" ?parseInt(fixNumbers( initialValues[ringItemId][1])) : 0,
      size_three_num:
        initialValues[ringItemId][2] !== "" ?parseInt(fixNumbers( initialValues[ringItemId][2])) : 0,
      size_four_num:
        initialValues[ringItemId][3] !== "" ?parseInt(fixNumbers( initialValues[ringItemId][3])) : 0,
      size_five_num:
        initialValues[ringItemId][4] !== "" ?parseInt(fixNumbers( initialValues[ringItemId][4])) : 0,
      size_six_num:
        initialValues[ringItemId][5] !== "" ?parseInt(fixNumbers( initialValues[ringItemId][5])) : 0,
      receive_at: moment(childrenItemDate).format("YYYY-MM-DD"),
    });
    updateDetailsApi.reFetch();
  };

  const delete_ring_item = (ringItemId, is_acitve) => {
    setSelectedItem(ringItemId);
    setSelectItemStatus(is_acitve);
    deleteDetailsApi.reFetch();
  };

  const move_date_to_parent = (date) => {
    setChildrenItemDate(date);
  };

  const admin_change_order_to_on_complete = () => {
    updateDetailsApi.reFetch();
  };

  useEffect(() => {
    if (openModal == true)
      if (props.selectedRow !== undefined)
        if (props.selectedRow.hasOwnProperty("id")) {
          getCreateOrderDetailsApi.reFetch();
        }
  }, [openModal]);

  return (
    <>
      <TableIconModal
        width="w-11/12"
        icon={<RemoveRedEyeIcon />}
        isOverflow={true}
        isNotBackdropClick={true}
        openModal={openModal}
        setOpenModal={setOpenModal}
      >
        <div>
          <div className="flex justify-between mb-2">
            <div className="add-item-container">
                <div className="ml-2">
                <span className="show-label">
                کد :{" "}
                <span className="show-value">
                  {" "}
                  {props.selectedRow?.code}
                </span>
              </span>
                </div>

              <span className="show-label">
                النگو:{" "}
                <span className="show-value mx-2 shrink-0">
                  {" "}
                  {props.selectedRow?.show_name}
                </span>
              </span>
            </div>
            {/* <div>
              <MuiButton
                onClick={admin_change_order_to_on_complete}
                variant="contained"
                icon={<DoneIcon />}
                color="primary"
                text="بروزرسانی نهایی "
                disabled={updateDetailsApi.loading}
              />
            </div> */}
          </div>
          <div className="overflow-scroll max-h-96">
            {/* {currentOerdersDetail.map((item, index) => {
              return [ */}
            {currentOerdersDetail !== undefined && (
              <AdminOrderCard
                update_ring_item={update_ring_item}
                delete_ring_item={delete_ring_item}
                showAcceptBtn
                DontshowEditIconForAdmin
                item={currentOerdersDetail}
                move_date_to_parent={move_date_to_parent}
                DontShowDatePicker
              >
                <OrderCardLeftPartTemplate
                  nums={nums}
                  update_nums={update_nums}
                  dynamicMap={true}
                  data_item={currentOerdersDetail}
                  ringId={currentOerdersDetail.id}
                  cantEdit
                  DontShowAcceptItem
                  customerCanEdit
                />
              </AdminOrderCard>
            )}
            {/* ]; */}
            {/* })} */}
          </div>
        </div>
      </TableIconModal>
    </>
  );
};

export default OrderDetails;
